import { ChangeEvent, useCallback, useEffect, useState } from 'react'
import { has } from 'ramda'

import PlainCheckbox from 'app/common/ui-next/plain-checkbox'

import styles from './AdditionalSettingsForm.scss'
import { Loading } from 'app/common/templates-next/page-template'


type CurrentValues = {
  disableForTerminalGuestSales: boolean
}

const defaultCurrent: CurrentValues = {
  disableForTerminalGuestSales: false,
}

type Props = {
  disableForTerminalGuestSales: boolean
  disabled: boolean
  loading: boolean
}

const AdditionalSettingsForm = ({
  disableForTerminalGuestSales,
  disabled,
  loading
}: Props) => {
  const [currentValues, setCurrentValues] = useState({
    disableForTerminalGuestSales,
  })

  const handleChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = e.currentTarget
    if (has(name, defaultCurrent)) {
      setCurrentValues(prevState => ({
        ...prevState,
        [name]: checked,
      }))
    }
  }, [])


  useEffect(() => {
    setCurrentValues({
      disableForTerminalGuestSales,
    })
  }, [
    disableForTerminalGuestSales,
  ])

  return (
    <div className={styles.root}>
      {loading ?
        <Loading className={styles.loading} /> :
        <div>
          <PlainCheckbox
            label="Не продавать гостям в терминале самообслуживания"
            name="disableForTerminalGuestSales"
            value="active"
            checked={currentValues.disableForTerminalGuestSales}
            onChange={handleChange}
            disabled={disabled}
          />
        </div>}
    </div>
  )
}

export default AdditionalSettingsForm
